import { withInstall, withNoopInstall } from '@bigin/utils'

import Checkbox from './src/checkbox.vue'
import CheckboxButton from './src/checkbox-button.vue'
import CheckboxGroup from './src/checkbox-group.vue'

export const BCheckbox = withInstall(Checkbox, {
  CheckboxButton,
  CheckboxGroup,
})
export default BCheckbox

export const BCheckboxButton = withNoopInstall(CheckboxButton)
export const BCheckboxGroup = withNoopInstall(CheckboxGroup)

export * from './src/checkbox-group'
export * from './src/checkbox'
